import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import api from "@/lib/api";
import { num } from "@/lib/format";
import { Panel } from "@/components/common";

const RANK_TONE = ["bg-blue-600", "bg-blue-500", "bg-indigo-500", "bg-sky-500", "bg-slate-400"];

export default function TopWipWidget() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/top-wip?limit=5").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  const rows = d.rows || [];
  const max = rows.length ? rows[0].open_wip : 1;
  return (
    <Panel className="mb-6" testId="top-wip-panel"
      title={<span className="inline-flex items-center gap-1.5 text-slate-800"><Layers className="w-3.5 h-3.5" />TOP 5 WORKER WIP TERBESAR</span>}
      action={<span className="text-[11px] text-slate-400" data-testid="top-wip-total">Total open WIP {num(d.total)} PCS · {num(d.jumlah_worker)} worker</span>}>
      {rows.length === 0 ? (
        <div className="text-sm text-slate-400 py-2" data-testid="top-wip-empty">Belum ada worker dengan Open WIP.</div>
      ) : (
        <div className="space-y-2.5">
          {rows.map((w, i) => (
            <Link key={w.worker_id} to={`/workers/${w.worker_id}`} className="flex items-center gap-3 group" data-testid={`top-wip-row-${w.worker_id}`}>
              <span className={`shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white ${RANK_TONE[i] || "bg-slate-400"}`}>{i + 1}</span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="truncate text-sm font-medium text-slate-800 group-hover:text-blue-600">
                    <span className="mono text-xs text-slate-400 mr-1.5">{w.worker_id}</span>
                    <span className="data-raw">{w.worker_name}</span>
                  </span>
                  <span className="shrink-0 mono font-bold text-slate-900" data-testid={`top-wip-qty-${w.worker_id}`}>{num(w.open_wip)} PCS</span>
                </div>
                <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                  <div className={`h-full rounded-full ${RANK_TONE[i] || "bg-slate-400"}`} style={{ width: `${Math.max((w.open_wip / max) * 100, 4)}%` }} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </Panel>
  );
}
